interface IInstantShipIcon {
  className?: string;
  width?: `${string}%` | number;
  height?: `${string}%` | number | 'auto';
  fill?: `#${string}` | 'black';
}

export const InstantShipIcon = ({
  className,
  width = 47,
  height = '100%',
  fill = '#4ADBB5',
}: IInstantShipIcon) => (
  <svg
    aria-label="instant ship"
    className={className}
    data-qa="instant_ship_icon"
    fill="none"
    height={height}
    viewBox="0 0 482 85"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14.7984 0L0 82.9259H12.2341L27.0325 0H14.7984Z" fill={fill} />
    <path
      d="M67.1181 20.6514C54.7771 20.6514 48.3663 27.4939 45.8019 31.7838L47.4403 22.0341H35.9007L25.0557 82.9255H36.9336L42.8814 49.0674C44.8581 38.6263 50.4498 30.277 61.0634 30.277C70.9646 30.277 73.6536 36.1978 73.6536 42.5794C73.6536 44.7775 73.2974 47.6847 72.9591 49.8828L67.3674 82.9433H79.1384L85.6561 46.0538C86.0123 43.8557 86.2438 40.9485 86.2438 38.8568C86.226 28.4157 80.0466 20.6514 67.1181 20.6514Z"
      fill={fill}
    />
    <path
      d="M121.183 20.2979C106.617 20.2979 96.84 28.1863 96.84 39.7796C96.84 49.4052 102.663 52.4188 112.458 55.7869L117.586 57.5241C124.335 59.8463 128.538 61.1226 128.538 66.4584C128.538 71.4396 124.229 75.499 115.253 75.499C105.584 75.499 101.381 69.4719 100.918 63.7816H90.3223C91.1414 77.5908 99.7605 85.0006 114.434 85.0006C130.052 85.0006 140.06 77.1122 140.06 64.3489C140.06 54.7233 133.061 51.7097 122.59 47.9871L118.868 46.6044C111.175 43.8213 108.611 42.545 108.611 37.9005C108.611 32.9193 112.921 29.7817 120.026 29.7817C127.131 29.7817 132.135 32.4407 133.186 39.1769H143.55V37.9005C143.55 26.325 134.005 20.2979 121.183 20.2979Z"
      fill={fill}
    />
    <path
      d="M165.934 69.4701C165.934 68.0874 166.059 66.4566 166.397 64.5953L172.345 31.0739H184.116L185.754 21.9092H173.983L177.01 5.54736H165.008L162.087 21.9092H152.525L150.886 31.0739H160.431L154.02 67.4847C153.664 69.8069 153.326 71.7746 153.326 73.7423C153.326 82.2157 161.126 84.2897 169.175 84.2897C170.92 84.2897 172.202 84.1833 173.716 83.9352L175.23 75.5859H173.485C167.911 75.6213 165.934 73.8841 165.934 69.4701Z"
      fill={fill}
    />
    <path
      d="M218.361 20.1733C202.512 20.1733 192.148 28.7531 190.047 41.1618H201.818C203.331 33.628 207.997 29.4444 216.972 29.4444C225.128 29.4444 229.563 33.628 229.563 40.2401C229.563 41.6227 228.975 44.654 228.975 45.4517L224.434 45.8063C207.89 47.0826 183.778 50.0961 183.778 68.4256C183.778 79.3276 192.629 84.0784 203.581 84.0784C215.227 84.0784 222.101 78.8667 225.36 74.8073C224.541 79.558 224.309 81.7739 224.309 82.9261H234.905C234.905 77.8208 235.831 70.7478 237.113 64.1358L239.784 50.4507C240.479 46.9762 240.942 43.1472 240.942 39.4423C240.96 26.7854 232.697 20.1733 218.361 20.1733ZM226.98 56.9387C224.648 68.6561 219.287 75.4986 207.873 75.4986C200.874 75.4986 196.333 72.5914 196.333 67.0252C196.333 55.5383 212.52 56.2296 227.675 53.4642L226.98 56.9387Z"
      fill={fill}
    />
    <path
      d="M288.631 20.6514C276.29 20.6514 269.879 27.4939 267.315 31.7838L268.953 22.0341H257.414L246.569 82.9255H258.447L264.395 49.0674C266.371 38.6263 271.963 30.277 282.576 30.277C292.478 30.277 295.167 36.1978 295.167 42.5794C295.167 44.7775 294.811 47.6847 294.472 49.8828L288.881 82.9433H300.652L307.169 46.0538C307.525 43.8557 307.757 40.9485 307.757 38.8568C307.739 28.4157 301.56 20.6514 288.631 20.6514Z"
      fill={fill}
    />
    <path
      d="M341.29 5.56543H329.287L326.367 21.9272H316.804L315.201 31.0743H324.764L318.353 67.4851C317.997 69.8073 317.659 71.7749 317.659 73.7426C317.659 82.216 325.459 84.2901 333.508 84.2901C335.253 84.2901 336.535 84.1837 338.049 83.9355L339.562 75.5862H337.817C332.226 75.5862 330.249 73.849 330.249 69.435C330.249 68.0523 330.356 66.4215 330.712 64.5601L336.66 31.0388H348.431L350.069 21.8741H338.298L341.29 5.56543Z"
      fill={fill}
    />
    <path
      d="M450.146 5.66748L441.911 12.1669L464.197 39.3495L347.324 39.3489V49.7166L464.197 49.7172L441.911 76.8998L450.146 83.3818L482 44.5246L450.146 5.66748Z"
      fill={fill}
    />
    <defs>
      <linearGradient
        id="paint0_linear_9281_174137"
        x1="347.329"
        y1="44.5318"
        x2="486.665"
        y2="44.5318"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity="0" />
        <stop offset="0.5" />
      </linearGradient>
    </defs>
  </svg>
);
